import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import useMobile from '../../../shared/hooks/useMobile';
import './section-product-stamps.scss';

const SectionProductStamps = ({ contentInfo }) => {

    const mobile = useMobile();

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-productStamps__content-title">{next}</p>
        }
    };

    const stampList = contentInfo.otrasCaracteristicas ? contentInfo.otrasCaracteristicas.map((categories, index) => {
        return (
            <div key={index}>
                <GatsbyImage
                    image={categories.imagenCategorias[0].gatsbyImageData}
                    alt={categories.imagenCategorias[0].description}
                    className="f-m-productStamps__content-stamp-img"
                />
            </div>

        )
    }) : null;

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className="f-m-slider-stamps-next"
                onClick={onClick}
            />
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className="f-m-slider-stamps-prev"
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        adaptiveHeight: true
    }

    return (
        <>
            {contentInfo.otrasCaracteristicas && <section className="f-m-productStamps">
                <div className="f-m-productStamps__content">
                    {
                        contentInfo.tituloOtrasCaracteristicas.raw && documentToReactComponents(JSON.parse(contentInfo.tituloOtrasCaracteristicas.raw), options)
                    }
                    {mobile ?
                        <div className="f-m-productStamps__content-container">
                            <Slider {...settings} className="f-m-productCategories__slider">
                                {stampList}
                            </Slider>
                        </div>
                        :
                        <div className="f-m-productStamps__content-stamp">
                            {stampList}
                        </div>
                    }

                </div>
            </section>}
        </>
    )
}

export default SectionProductStamps
